"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectionStateHandler = exports.ConnectionStateEvent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _internalMediaCore = require("@webex/internal-media-core");
var _eventsScope = _interopRequireDefault(require("../common/events/events-scope"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ConnectionStateEvent = exports.ConnectionStateEvent = {
  stateChanged: 'connectionState:changed'
};
/**
 * @class ConnectionStateHandler
 */
var ConnectionStateHandler = exports.ConnectionStateHandler = /*#__PURE__*/function (_EventsScope) {
  (0, _inherits2.default)(ConnectionStateHandler, _EventsScope);
  var _super = _createSuper(ConnectionStateHandler);
  /**
   * @param {WebRTCMeeting} webrtcMediaConnection
   */
  function ConnectionStateHandler(webrtcMediaConnection) {
    var _this;
    (0, _classCallCheck2.default)(this, ConnectionStateHandler);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "webrtcMediaConnection", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mediaConnectionState", void 0);
    _this.webrtcMediaConnection = webrtcMediaConnection;
    _this.webrtcMediaConnection.on(_internalMediaCore.MediaConnectionEventNames.PEER_CONNECTION_STATE_CHANGED, _this.handleConnectionStateChange.bind((0, _assertThisInitialized2.default)(_this)));
    _this.webrtcMediaConnection.on(_internalMediaCore.MediaConnectionEventNames.ICE_CONNECTION_STATE_CHANGED, _this.handleConnectionStateChange.bind((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  /**
   * Handler for connection state change.
   *
   * @returns {void}
   */
  (0, _createClass2.default)(ConnectionStateHandler, [{
    key: "handleConnectionStateChange",
    value: function handleConnectionStateChange() {
      var newConnectionState = this.webrtcMediaConnection.getConnectionState();
      if (newConnectionState !== this.mediaConnectionState) {
        this.mediaConnectionState = newConnectionState;
        this.emit({
          file: 'connectionStateHandler',
          function: 'handleConnectionStateChange'
        }, ConnectionStateEvent.stateChanged, {
          state: this.mediaConnectionState
        });
      }
    }
  }]);
  return ConnectionStateHandler;
}(_eventsScope.default);
//# sourceMappingURL=connectionStateHandler.js.map
